import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import * as autoThunks from 'features/auto-thunks'
import ContentHouseMediaSnapshot from './content-house-media-snapshot-model'
import {
  CreateContentHouseMediaSnapshotAsync,
  DeleteContentHouseMediaSnapshotAsync,
  LoadContentHouseMediaSnapshotsAsync,
} from './contentHouseMediaSnapshot-thunk'
const initialState: contentHouseMediaSnapshotSliceState = {
  contentHouseMediaSnapshot: [],
  selected_contentHouseMediaSnapshot: '',
  is_loading_contentHouseMediaSnapshot: false,
  is_creating_contentHouseMediaSnapshot: false,
  is_deleting_contentHouseMediaSnapshot: false,
}
export interface contentHouseMediaSnapshotSliceState {
  contentHouseMediaSnapshot: ContentHouseMediaSnapshot[]
  selected_contentHouseMediaSnapshot?: string
  is_loading_contentHouseMediaSnapshot: boolean
  is_creating_contentHouseMediaSnapshot: boolean
  is_deleting_contentHouseMediaSnapshot: boolean
}
export const contentHouseMediaSnapshotSlice = createSlice({
  name: 'contentHouseMediaSnapshot',
  initialState,
  reducers: {
    setSelectedcontentHouseMediaSnapshot: (state, action) => {
      state.selected_contentHouseMediaSnapshot = action.payload
    },
    clearStatecontentHouseMediaSnapshot: (state) => {
      state.contentHouseMediaSnapshot = []
      state.is_loading_contentHouseMediaSnapshot = false
      state.is_creating_contentHouseMediaSnapshot = false
      state.is_deleting_contentHouseMediaSnapshot = false
    },
    mergecontentHouseMediaSnapshot: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_contentHouseMediaSnapshot = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.contentHouseMediaSnapshot = merge(
            state.contentHouseMediaSnapshot,
            payload,
          ) as any
        }
      }
    },

    add_contentHouseMediaSnapshot: (state, action) => {
      if (action.payload) {
        state.contentHouseMediaSnapshot = [
          ...state.contentHouseMediaSnapshot,
          action.payload,
        ]
      }
    },
    set_contentHouseMediaSnapshot: (state, action) => {
      let { key, value, id } = action.payload
      state.contentHouseMediaSnapshot = state.contentHouseMediaSnapshot.map(
        (item) => {
          if (item && item.id === id) {
            return {
              ...item,
              [key]: value,
            }
          }
          return item
        },
      )
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadContentHouseMediaSnapshotsAsync.pending, (state) => {
      state.is_loading_contentHouseMediaSnapshot = true
    })
    builder.addCase(
      LoadContentHouseMediaSnapshotsAsync.fulfilled,
      (state, action) => {
        state.is_loading_contentHouseMediaSnapshot = false
        if (action.payload) {
          state.contentHouseMediaSnapshot = action.payload
        }
      },
    )
    builder.addCase(LoadContentHouseMediaSnapshotsAsync.rejected, (state) => {
      state.is_loading_contentHouseMediaSnapshot = false
    })
    builder.addCase(CreateContentHouseMediaSnapshotAsync.pending, (state) => {
      state.is_creating_contentHouseMediaSnapshot = true
    })
    builder.addCase(CreateContentHouseMediaSnapshotAsync.fulfilled, (state) => {
      state.is_creating_contentHouseMediaSnapshot = false
    })
    builder.addCase(CreateContentHouseMediaSnapshotAsync.rejected, (state) => {
      state.is_creating_contentHouseMediaSnapshot = false
    })
    builder.addCase(DeleteContentHouseMediaSnapshotAsync.pending, (state) => {
      state.is_deleting_contentHouseMediaSnapshot = true
    })
    builder.addCase(
      DeleteContentHouseMediaSnapshotAsync.fulfilled,
      (state, action) => {
        state.is_deleting_contentHouseMediaSnapshot = false
        if (state.contentHouseMediaSnapshot) {
          state.contentHouseMediaSnapshot =
            state.contentHouseMediaSnapshot.filter(
              (x) => action.payload.id !== x.id,
            )
        }
      },
    )
    builder.addCase(DeleteContentHouseMediaSnapshotAsync.rejected, (state) => {
      state.is_deleting_contentHouseMediaSnapshot = false
    })

    builder.addCase(
      autoThunks
        .get_content_house_media_snapshot_for_release_management_by_content_house
        .pending,
      (state) => {
        state.is_loading_contentHouseMediaSnapshot = true
      },
    )
    builder.addCase(
      autoThunks
        .get_content_house_media_snapshot_for_release_management_by_content_house
        .fulfilled,
      (state, action) => {
        state.is_loading_contentHouseMediaSnapshot = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks
        .get_content_house_media_snapshot_for_release_management_by_content_house
        .rejected,
      (state) => {
        state.is_loading_contentHouseMediaSnapshot = false
      },
    )
  },
})

function handleResult(action: any, state: contentHouseMediaSnapshotSliceState) {
  if (action.payload) {
    let payload: any = action.payload
    if (payload?.data) {
      if (!Array.isArray(payload.data)) {
        state.selected_contentHouseMediaSnapshot = payload?.data?.id
        payload = [payload.data]
      } else {
        payload = payload.data
      }
      state.contentHouseMediaSnapshot = merge(
        state.contentHouseMediaSnapshot,
        payload,
      ) as any
    }
  }
}

export const {
  clearStatecontentHouseMediaSnapshot,
  setSelectedcontentHouseMediaSnapshot,
  set_contentHouseMediaSnapshot,
  mergecontentHouseMediaSnapshot,
  add_contentHouseMediaSnapshot,
} = contentHouseMediaSnapshotSlice.actions

export const get_contentHouseMediaSnapshot =
  (id?: string) =>
  (state: {
    contentHouseMediaSnapshot: {
      contentHouseMediaSnapshot: ContentHouseMediaSnapshot[]
    }
  }): ContentHouseMediaSnapshot | null => {
    let temp =
      state?.contentHouseMediaSnapshot?.contentHouseMediaSnapshot?.find(
        (v) => v.id === id,
      )
    if (temp) {
      return temp
    }
    return (
      state?.contentHouseMediaSnapshot?.contentHouseMediaSnapshot[0] || null
    )
  }
export const get_selected_contentHouseMediaSnapshot = (state: {
  contentHouseMediaSnapshot: contentHouseMediaSnapshotSliceState
}): ContentHouseMediaSnapshot | null => {
  let id = state?.contentHouseMediaSnapshot?.selected_contentHouseMediaSnapshot
  let temp = state?.contentHouseMediaSnapshot?.contentHouseMediaSnapshot?.find(
    (v) => v.id === id,
  )
  if (temp) {
    return temp
  }
  return null
}
export const get_all_contentHouseMediaSnapshot = (state: {
  contentHouseMediaSnapshot: {
    contentHouseMediaSnapshot: ContentHouseMediaSnapshot[]
  }
}): ContentHouseMediaSnapshot[] => {
  let temp = state?.contentHouseMediaSnapshot?.contentHouseMediaSnapshot
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_contentHouseMediaSnapshot_busy = (state: {
  contentHouseMediaSnapshot: contentHouseMediaSnapshotSliceState
}) => {
  return (
    state?.contentHouseMediaSnapshot.is_deleting_contentHouseMediaSnapshot ||
    state?.contentHouseMediaSnapshot.is_loading_contentHouseMediaSnapshot ||
    state?.contentHouseMediaSnapshot.is_creating_contentHouseMediaSnapshot
  )
}
export const is_deleting_contentHouseMediaSnapshot_busy = (state: {
  contentHouseMediaSnapshot: contentHouseMediaSnapshotSliceState
}) => {
  return state?.contentHouseMediaSnapshot.is_deleting_contentHouseMediaSnapshot
}
export const is_loading_contentHouseMediaSnapshot_busy = (state: {
  contentHouseMediaSnapshot: contentHouseMediaSnapshotSliceState
}) => {
  return state?.contentHouseMediaSnapshot.is_loading_contentHouseMediaSnapshot
}
export const is_creating_contentHouseMediaSnapshot_busy = (state: {
  contentHouseMediaSnapshot: contentHouseMediaSnapshotSliceState
}) => {
  return state?.contentHouseMediaSnapshot.is_creating_contentHouseMediaSnapshot
}

export default contentHouseMediaSnapshotSlice.reducer
